import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { StyleSheetManager } from 'styled-components';

const host = document.querySelector('coco-timeline');
console.log(host);
const shadow = host.attachShadow({ mode: 'open' });
const styleSlot = document.createElement("section");
shadow.appendChild(styleSlot);
const renderIn = document.createElement("div");
renderIn.setAttribute('role','none');
styleSlot.appendChild(renderIn);
const root = ReactDOM.createRoot(renderIn);
root.render(
  <StyleSheetManager target={styleSlot}>
      <App />
  </StyleSheetManager>
);
